// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxOCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4yMjQ1IDEuMTQ3MUMxNi40NTc3IDAuODk2MDIyIDE2Ljg0ODQgMC44ODMzNzUgMTcuMDk3IDEuMTE4ODVDMTcuMzMxMSAxLjM0MDQ4IDE3LjM1NTkgMS43MDI5IDE3LjE2MzYgMS45NTQxTDE3LjEyNSAxLjk5OTgzTDYuNjcxNzUgMTIuNjM2MkM2LjQ0ODQxIDEyLjg3NjcgNi4wODE3MSAxMi44OTc4IDUuODMzMzUgMTIuNjk0NUw1Ljc4ODIzIDEyLjY1MzhMMC44MDkwMTQgNy42OTk1NUMwLjU2NjE4NyA3LjQ1Nzk0IDAuNTYzMzE4IDcuMDYzMzIgMC44MDI2MDcgNi44MTgxNEMxLjAyNzgyIDYuNTg3MzggMS4zODcyNyA2LjU3MTI0IDEuNjMxMjMgNi43NzE1N0wxLjY3NTU1IDYuODExNjdMNi4yMDQwOSAxMS4zMTc0TDE2LjIyNDUgMS4xNDcxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-item {
  display: flex;
  align-items: center;
  margin: 0px;
  position: relative;
}
.checkbox-item.item-checked .checkbox-input:checked + .checkbox-label {
  background: var(--sdk-gloabl-bg-secondary);
}
.checkbox-item.select-all {
  border: 0px !important;
}
.checkbox-item.select-all .checkbox-input {
  left: 0.5px;
  top: 0.5px;
}
.checkbox-item.select-all .checkbox-input + .checkbox-label {
  padding: 0 0 0 26px;
}
.checkbox-item.select-all .checkbox-input + .checkbox-label::before {
  left: 0px;
  top: 0px;
}
.checkbox-item .checkbox-input {
  position: absolute;
  cursor: pointer;
  margin: 0;
  width: 14.5px;
  height: 15.1px;
  top: 10.5px;
  left: 10.5px;
  border: 0;
}
.checkbox-item .checkbox-input + .checkbox-label {
  width: 100%;
  cursor: pointer;
  position: relative;
  padding: 10px;
  padding-left: 36px;
  border-radius: 2px;
}
.checkbox-item .checkbox-input + .checkbox-label .title {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
.checkbox-item .checkbox-input + .checkbox-label .desc-text-checkbox {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 2px;
}
.checkbox-item .checkbox-input + .checkbox-label::before {
  content: "";
  width: 16px;
  height: 16px;
  padding: 0;
  text-align: center;
  position: absolute;
  left: 10px;
  top: 10px;
  margin: 0;
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  box-sizing: border-box;
}
.checkbox-item .checkbox-input:checked + .checkbox-label::before {
  content: "";
  border: 1px solid var(--sdk-global-theme-color);
  background: var(--sdk-global-theme-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-size: 12px 12px;
  background-position: center;
}
.checkbox-item .checkbox-input:checked:focus + .checkbox-label {
  color: var(--sdk-gloabl-text-color);
}
.checkbox-item .checkbox-input:checked:disabled {
  pointer-events: none;
}
.checkbox-item .checkbox-input:checked:disabled + .checkbox-label {
  pointer-events: none !important;
  opacity: 0.7;
}
.checkbox-item .checkbox-input:disabled {
  pointer-events: none;
  opacity: 0.2;
}
.checkbox-item .checkbox-input:disabled + .checkbox-label {
  pointer-events: none !important;
  opacity: 0.7;
}
.checkbox-item.if-dark-theme-checkbox .checkbox-input:checked + .checkbox-label::before {
  background-color: var(--sdk-global-white-bg);
}

.checkbox-wrapper {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.checkbox-wrapper h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
}
.checkbox-wrapper .checkbox-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.checkbox-wrapper .checkbox-container .checkbox-item {
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  width: 100%;
}
.checkbox-wrapper .checkbox-container .checkbox-item .checkbox-input + .checkbox-label .title {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/checkBoxes/checkBoxes.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAFJ;AAOgB;EACI,0CAAA;AALpB;AAUI;EACI,sBAAA;AARR;AASQ;EACI,WAAA;EACA,UAAA;AAPZ;AAQY;EACI,mBAAA;AANhB;AAOgB;EACI,SAAA;EACA,QAAA;AALpB;AAUI;EACI,kBAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AARR;AASQ;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAPZ;AAQY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AANhB;AAQY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AANhB;AAQY;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,sBAAA;AANhB;AAWgB;EACI,WAAA;EACA,+CAAA;EACA,yCAAA;EACA,yDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;AATpB;AAagB;EACI,mCAAA;AAXpB;AAcY;EACI,oBAAA;AAZhB;AAagB;EACI,+BAAA;EACA,YAAA;AAXpB;AAeQ;EACI,oBAAA;EACA,YAAA;AAbZ;AAcY;EACI,+BAAA;EACA,YAAA;AAZhB;AAoBoB;EACI,4CAAA;AAlBxB;;AA0BA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAvBJ;AAwBI;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAtBR;AAwBI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAtBR;AAuBQ;EACI,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,WAAA;AArBZ;AAwBoB;EACI,gBAAA;AAtBxB","sourcesContent":["\n\n\n.checkbox-item{\n    display: flex;\n    align-items: center;\n    margin: 0px;\n    position: relative;\n    // padding: 10px;\n    &.item-checked{        \n        .checkbox-input{\n            &:checked{\n                + .checkbox-label{\n                    background: var(--sdk-gloabl-bg-secondary);\n                }\n            }\n        }\n    }\n    &.select-all{\n        border:0px !important;\n        .checkbox-input{\n            left: 0.5px;\n            top: 0.5px;\n            + .checkbox-label{\n                padding: 0 0 0 26px;\n                &::before{\n                    left: 0px;\n                    top: 0px;\n                }\n            }\n        }\n    }\n    .checkbox-input{\n        position: absolute;\n        cursor: pointer;\n        margin: 0;\n        width: 14.5px;\n        height: 15.1px;\n        top: 10.5px;\n        left: 10.5px;\n        border: 0;\n        + .checkbox-label{\n            width: 100%;\n            cursor: pointer;\n            position: relative;\n            padding: 10px;\n            padding-left: 36px;\n            border-radius: 2px;\n            .title{\n                color: var(--sdk-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 400;\n                line-height: normal;\n            }\n            .desc-text-checkbox{\n                color: var(--sdk-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 20px;\n                margin-top: 2px;\n            }\n            &::before{\n                content: '';\n                width: 16px;\n                height: 16px;\n                padding: 0;               \n                text-align: center;               \n                position: absolute;\n                left: 10px;\n                top: 10px;\n                margin: 0;\n                border-radius: 4px;\n                border: 1px solid var(--sdk-gloabl-border-color);\n                background: var(--sdk-global-white-bg);\n                box-sizing: border-box;\n            }\n        }\n        &:checked{\n            + .checkbox-label{\n                &::before{\n                    content: \"\";\n                    border: 1px solid var(--sdk-global-theme-color);\n                    background:var(--sdk-global-theme-color);\n                    background-image: url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxOCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4yMjQ1IDEuMTQ3MUMxNi40NTc3IDAuODk2MDIyIDE2Ljg0ODQgMC44ODMzNzUgMTcuMDk3IDEuMTE4ODVDMTcuMzMxMSAxLjM0MDQ4IDE3LjM1NTkgMS43MDI5IDE3LjE2MzYgMS45NTQxTDE3LjEyNSAxLjk5OTgzTDYuNjcxNzUgMTIuNjM2MkM2LjQ0ODQxIDEyLjg3NjcgNi4wODE3MSAxMi44OTc4IDUuODMzMzUgMTIuNjk0NUw1Ljc4ODIzIDEyLjY1MzhMMC44MDkwMTQgNy42OTk1NUMwLjU2NjE4NyA3LjQ1Nzk0IDAuNTYzMzE4IDcuMDYzMzIgMC44MDI2MDcgNi44MTgxNEMxLjAyNzgyIDYuNTg3MzggMS4zODcyNyA2LjU3MTI0IDEuNjMxMjMgNi43NzE1N0wxLjY3NTU1IDYuODExNjdMNi4yMDQwOSAxMS4zMTc0TDE2LjIyNDUgMS4xNDcxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==\");\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    background-repeat: no-repeat;\n                    background-size: 12px 12px;\n                    background-position: center;\n                }\n            }\n            &:focus{\n                + .checkbox-label{\n                    color: var(--sdk-gloabl-text-color);\n                }\n            }\n            &:disabled{\n                pointer-events: none;   \n                + .checkbox-label{\n                    pointer-events: none !important;\n                    opacity: 0.7;\n                }\n            }\n        }\n        &:disabled{\n            pointer-events: none;\n            opacity: 0.2;\n            + .checkbox-label{\n                pointer-events: none !important;\n                opacity: 0.7;\n            }\n        }\n    }\n    &.if-dark-theme-checkbox{\n        .checkbox-input{\n            &:checked{\n                + .checkbox-label{\n                    &::before{\n                        background-color: var(--sdk-global-white-bg);\n                    }\n                }\n            }\n        }\n    }\n}\n\n.checkbox-wrapper{\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    h1{\n        color: var(--sdk-gloabl-text-color);\n        font-size: 14px;\n        font-weight: 700;\n        line-height: normal;\n    }\n    .checkbox-container{\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        .checkbox-item{\n            border-radius: 4px;\n            border: 1px solid var(--sdk-gloabl-border-color);\n            background: var(--sdk-global-white-bg);\n            width: 100%;\n            .checkbox-input {\n                + .checkbox-label {\n                    .title{\n                        font-weight: 500;\n                    }\n                }\n            }\n        }\n    }    \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
